import { apiRequest } from "../../util/api";
import { getEndpointDashboard } from "../../util/constants";

const AGENT_LIST_LIMIT = 10000;

export const getLocationReport = () =>
    apiRequest({
        baseUrl: getEndpointDashboard(),
        url: "/dashboard/cross_report/location",
        method: "GET",
    });

export const getLocationActivityReport = (locationId: number) =>
    apiRequest({
        baseUrl: getEndpointDashboard(),
        url: `/dashboard/cross_report/location/${locationId}/activity`,
        method: "GET",
    });

export const getAgentReport = (agentFilterValues: string[] = []) =>
    apiRequest({
        baseUrl: getEndpointDashboard(),
        url: `/dashboard/cross_report/agent?limit=${AGENT_LIST_LIMIT}&${agentFilterValues
            .map((f) => `${f}=1`)
            .join("&")}`,
        method: "GET",
    });
